export default Object.freeze({
  requests: 1,
  ndfl3: 2,
  taxMessage: 3,
  payment: 4,
  insurancePayment: 5,
  info: 6,
  infoForAnswer: 9,
  administrativeProceeding: 10,
});
